module.exports = __webpack_public_path__ + "img/technology-item-2.dff9c7b8.png";